import {configureStore, Middleware} from '@reduxjs/toolkit';
import {useDispatch} from 'react-redux';
import {createLogger} from 'redux-logger';
import promise from 'redux-promise-middleware';

// RTK Slices (migrated - 11/11 complete)
import categoryReducer from './redux/slice/categorySlice';
import filterDefaultsReducer from './redux/slice/filterDefaultsSlice';
import loaderReducer from './redux/slice/loaderSlice';
import loginReducer from './redux/slice/loginSlice';
import messageReducer from './redux/slice/messageSlice';
import myReportsReducer from './redux/slice/myReportsSlice';
import reportTypeReducer from './redux/slice/reportTypeSlice';
import seasonReducer from './redux/slice/seasonSlice';
import summaryFilterReducer from './redux/slice/summaryFilterSlice';
import unreadIncidentsReducer from './redux/slice/unreadIncidentsSlice';
import i18nReducer from './i18n/slice/i18nSlice';

const logger = createLogger({
    predicate: () => false // set to true for logging
});

export const store = configureStore({
    reducer: {
        i18n: i18nReducer,
        login: loginReducer,
        message: messageReducer,
        category: categoryReducer,
        filterDefaults: filterDefaultsReducer,
        season: seasonReducer,
        reportType: reportTypeReducer,
        loader: loaderReducer,  // Now using RTK slice!
        unreadIncidents: unreadIncidentsReducer,
        myReports: myReportsReducer,
        summaryFilter: summaryFilterReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['PROMISE'],
                ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
                ignoredPaths: ['items.dates']
            }
        }).concat(promise as Middleware, logger as Middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = useDispatch.withTypes<AppDispatch>();